<script lang="ts">
    import {dyData, modal} from 'general/store';
    import {TEMPLATE} from 'general/constants';

    import Description from 'general/components/description/Description.svelte';
    import Logo from 'general/components/logo/Logo.svelte';
    import ScrollItem from 'general/components/scrollItem/ScrollItem.svelte';
    import RoundButton from 'desktop/components/roundButton/RoundButton.svelte';
    import RoundCheckIcon from 'general/icons/RoundCheckLarge.svelte';

    import s from './style.module.css';

    const dyIcon = Array.isArray($dyData.saleText?.typ)
        ? $dyData.saleText?.typ[0].icon
        : $dyData.saleText?.typ?.icon;
</script>

<ScrollItem>
    <div class={s.main} style="margin-top: {$dyData.side.typ?.marginTop || 0}">
        <Logo side="typ" />
        <div class={s.wrapper}>
            <div
                class={s.checkIcon}
                style="background-color: {dyIcon?.backgroundColor || '#E0F6ED'};
            margin-top: {dyIcon?.marginTop || '149px'};
            margin-bottom: {dyIcon?.marginBottom || '9px'}"
            >
                <RoundCheckIcon size={36} color={dyIcon?.color || '#00995C'} />
            </div>
        </div>
        <Description template={TEMPLATE.SQUARE_PRODUCT} value={$dyData.description?.typ} />
        <RoundButton
            type="button"
            children="Continue Shopping"
            onClick={modal.close}
            template={TEMPLATE.SQUARE_PRODUCT}
            side="typ"
        />
    </div>
</ScrollItem>
